import { useTranslation } from 'react-i18next'

import { AlertDropDown, Link, Text } from '@reveni-io/reveni-ui'

import routes from '@/Router/routes.constants'

const ReturnGroupReminder = ({ returnGroup, currentId }) => {
  const { t, i18n } = useTranslation()

  const groupReturns = returnGroup?.returns?.filter(r => r.id !== currentId).map(r => r.order_name) || []

  const getLinkByOrderName = orderName => {
    return routes.transactionDetailPage.replace(':id', returnGroup.returns.find(r => r.order_name === orderName).id)
  }

  const getListOfReturns = () => {
    const listFormat = new Intl.ListFormat(i18n.language, { style: 'long', type: 'conjunction' })

    return listFormat.formatToParts(groupReturns).map(({ type, value }) => {
      if (type === 'element') {
        return (
          <Link target="_blank" href={getLinkByOrderName(value)} key={value}>
            <Text type="bodySRegular">{value}</Text>
          </Link>
        )
      }
      return value
    })
  }

  if (!returnGroup || !returnGroup?.returns?.length) return null

  return (
    <AlertDropDown title={t('Esto es una devolución conjunta')} options={{ withoutDropDown: true }}>
      {groupReturns?.length > 1 ? (
        <Text type="bodySRegular">
          {t('Esta etiqueta incluye productos de los pedidos ')} {getListOfReturns()}{' '}
          {t('que se han devuelto junto con los de este pedido.')}
        </Text>
      ) : (
        <Text type="bodySRegular">
          {t('Esta etiqueta incluye productos del pedido ')} {getListOfReturns()}{' '}
          {t('que se han devuelto junto con los de este pedido.')}
        </Text>
      )}
    </AlertDropDown>
  )
}

export default ReturnGroupReminder
